import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import App from './App';
import { store } from './store';
import { ThemeProvider as AppThemeProvider } from './contexts/ThemeContext';
import { createAppTheme } from './theme';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Wrapper komponenta koja koristi theme context
const AppWithTheme = () => {
  const [isDarkMode] = React.useState(() => {
    // Uvek počni sa dark mode-om po defaultu
    return true;
  });

  const theme = React.useMemo(() => createAppTheme(isDarkMode), [isDarkMode]);

  React.useEffect(() => {
    // Set body background based on theme
    document.body.style.background = isDarkMode 
      ? 'linear-gradient(135deg, #0F1431 0%, #171B46 100%)' 
      : '#ffffff';
    document.body.style.color = isDarkMode ? '#ffffff' : '#000000';
  }, [isDarkMode]);

  return (
    <AppThemeProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme={isDarkMode ? "dark" : "light"}
        />
      </ThemeProvider>
    </AppThemeProvider>
  );
};

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <AppWithTheme />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);


